export const EVENT_TYPES = {
  PLAYBACK_STATE_CHANGE: 'PLAYBACK_STATE_CHANGE',
  PLAYBACK_TIME_CHANGE: 'PLAYBACK_TIME_CHANGE',
  GENERATION_PROGRESS_UPDATE: 'GENERATION_PROGRESS_UPDATE'
}

// Type for event names to enable autocomplete
export type TEventType = keyof typeof EVENT_TYPES
